import { createStore, applyMiddleware, compose } from 'redux';
import { initialState } from './initial-state';
import { rootReducer } from './reducers';
import thunk from 'redux-thunk';

const enhancers = [applyMiddleware(thunk)];

const composedEnhancers = compose(
  ...enhancers
);

const store = createStore(rootReducer, initialState, composedEnhancers);


export default store;
